import roleOptions from 'constants/roleOptions'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import castArray from 'lodash/castArray'

import rules from './rules.ts'

const getUserRoles = roleId => roleOptions.filter(({id}) => id === roleId).map(({name}) => name)

const check = ({role, action, data}) => {
  const permissions = rules[role]
  if (!permissions) {
    // role is not present in the rules
    return false
  }

  const staticPermissions = permissions.static

  if (staticPermissions && staticPermissions.includes(action)) {
    // static rule not provided for action
    return true
  }

  const dynamicPermissions = permissions.dynamic

  if (dynamicPermissions) {
    const permissionCondition = dynamicPermissions[action]
    if (!permissionCondition) {
      // dynamic rule not provided for action
      return false
    }

    return permissionCondition(data)
  }
  return false
}

const hasPermission = ({permissions, roles, data}) => {
  const actions = castArray(permissions)

  return roles?.some(role => actions.some(action => check({role, action, data})))
}

const CanWithRole = ({perform, data, roles, no, yes, render}) => {
  const acceptRole = hasPermission({permissions: perform, roles, data})

  if (render) {
    return render(acceptRole)
  }

  return acceptRole ? yes() : no()
}

CanWithRole.defaultProps = {
  yes: () => null,
  no: () => null,
}

CanWithRole.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  yes: PropTypes.func,
  no: PropTypes.func,
  perform: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
}

export {CanWithRole, getUserRoles, hasPermission}

export default connect(({account}) => ({
  roles: account.hasAccess && account.roleId ? getUserRoles(account.roleId) : [], // If there is no access or roleId - return an empty array
}))(CanWithRole)
